import React from 'react';

const StrukturDataNonLinierCP: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p className="mb-4">
        Dalam dunia <b>Competitive Programming (CP)</b> tingkat lanjut, persoalan pembaruan nilai dan penarikan informasi pada rentang data (<i>Range Query Problem</i>) sering kali menjadi penentu kelolosan peserta. Ketika batas data mencapai ratusan ribu elemen, pendekatan linier sederhana dipastikan akan berujung pada status <i>Time Limit Exceeded</i>.
      </p>

      <p className="mb-4">
        Untuk menjawab tantangan tersebut, penguasaan struktur data pohon non-linier seperti <b>Segment Tree</b> dan <b>Binary Indexed Tree (Fenwick Tree)</b> menjadi senjata wajib. Keduanya memungkinkan operasi <i>point update</i>, <i>range update</i>, dan <i>range query</i> diselesaikan dalam waktu logaritmik O(log N) yang sangat efisien.
      </p>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Memilih Antara Segment Tree dan Fenwick Tree
      </h2>
      <p className="mb-4">
        Meskipun memiliki tujuan yang serupa, kedua struktur data ini memiliki karakteristik dan keunggulan masing-masing yang perlu disesuaikan dengan kebutuhan soal:
      </p>

      <ul className="list-disc pl-6 mb-6 space-y-3">
        <li>
          <strong>Fenwick Tree (Binary Indexed Tree):</strong> Sangat hemat memori (hanya membutuhkan array berukuran N) dan memiliki baris kode implementasi yang sangat ringkas. Cocok untuk operasi kumulatif seperti <i>Range Sum Query</i> dengan modifikasi titik.
        </li>
        <li>
          <strong>Segment Tree:</strong> Membutuhkan memori sekitar 4N, namun jauh lebih fleksibel. Struktur ini mampu menangani operasi kompleks seperti mencari nilai minimum/maksimum (RMQ), gcd rentang, hingga teknik <i>Lazy Propagation</i> untuk pembaruan rentang data secara massal.
        </li>
      </ul>

      <h2 className="text-lg font-semibold text-gray-800 mt-6 mb-3">
        Teknik Optimasi: Lazy Propagation
      </h2>
      <p className="mb-4">
        Pada persoalan yang menuntut pembaruan interval nilai secara berulang, teknik <i>Lazy Propagation</i> menunda proses pembaruan node anak hingga informasi tersebut benar-benar dibutuhkan pada query berikutnya. Hal ini mencegah penurunan performa ke O(N) dan menjaga kompleksitas tetap pada O(log N).
      </p>

      <p className="mb-4">
        Penguasaan struktur data tingkat lanjut ini membekali peserta dengan cara pandang komputasi yang efisien, memungkinkan mereka menaklukkan soal-soal berkategori sulit di berbagai ajang kontes pemrograman nasional maupun internasional.
      </p>
    </div>
  );
};

export default StrukturDataNonLinierCP;
